export const INVENTORY_KANBAN_STAGES = [
    'inProcess',
    'readyUnassigned',
    'readyAssigned',
];
export const RENEWAL_ROBOT_ACTIONS = ['RETURN', 'CARRY'];
/**
 * 이벤트 일정(2026-11-02 오너 — "일정에 '이벤트'도 추가하자"). 행사장에 로봇을 내보냈다가 거둬 오는 일.
 *   · 설치일 → 캘린더 [이벤트 설치], 회수일 → [이벤트 회수] — 일정 두 개.
 *   · 출고할 로봇은 모델 · 대수만 적고, 로봇 배정 화면에서 재고 로봇을 배정한다. 배정한 로봇은 이벤트에
 *     예약돼 계약 배정 후보에서 빠지고, [회수 완료]를 누르면 예약이 풀리고 로봇은 '정비'로 들어간다.
 *   · 준비물 체크 리스트는 구글 캘린더 일정 설명(메모)에 적힌다.
 * GET /schedule-dates/events.
 */
export const EVENT_PREP_ITEMS = [
    '그릴러',
    '그릴러 디스플레이 파티션',
    '디스플레이 리모컨',
    '불판거치대',
    '불판',
    '와이어그릴',
    '고기 모형',
    '라우터',
    '태블릿',
    '멀티탭',
    'AC파워케이블',
];
/**
 * 이벤트 유형(2026-11-02 오너 — "이벤트 일정 추가란에서 이벤트 유형을 고를 수 있게") — 로봇 배치의 '유형'
 * 가운데 고객 배치를 뺀 다섯. [설치 완료]가 만드는 출고 기록의 유형(Deployment.kind)이 된다. 표기는
 * DEPLOYMENT_KIND_LABELS.
 */
/**
 * 장소 이름으로 네이버 지도를 검색하는 링크(2026-11-02 오너 — "장소도 검색해서 네이버 지도 주소 링크 붙히게").
 * 지도 링크를 따로 붙이지 않은 이벤트는 이 링크를 쓴다.
 */
export const naverMapSearchUrl = (place) => `https://map.naver.com/p/search/${encodeURIComponent(place.trim())}`;
export const CALENDAR_EVENT_KINDS = [
    'EVENT',
    'PILOT',
    'CERTIFICATION',
    'TEST',
    'INTERNAL',
];
/**
 * 개선 9건 차수1(26-08-04) 결정 ①A — **회수 장소**.
 *
 * 종전 고객 회수는 "정비 입고 = A/S센터" 로 못박혀 있었다. 연구소로 분석하러
 * 보내는 로봇도, 공장 재입고도, 창고 보관도 전부 A/S센터로 기록됐다.
 *
 * 값은 LocationCategory 의 부분집합이다(새 enum 을 만들지 않는다 — 위치 분류는
 * 로봇 등록·편집이 쓰는 정본 하나뿐이어야 한다). 회수가 갈 수 있는 곳만 남긴
 * 것: 고객 현장(CUSTOMER_SITE)은 회수의 반대이고, 폐기(DISPOSAL)는 처분
 * (disposition=RETIRE)이 담당한다.
 *
 * **상태는 IN_AS 를 유지한다**(위치-상태 분리) — 대시보드 '정비 중' 수치, 마지막
 * 로봇 회수 시 고객사 자동 종료, 계약 예약 해제가 전부 종전 그대로 간다.
 *
 * ⚠ 결정 ①A: 정비 작업 지시(ServiceOrder) 자동 생성은 **A/S센터·공장만**.
 * 연구소·창고 입고는 수리 목적이 아니라 지시가 인박스 노이즈가 된다. 대신 그
 * 로봇은 IN_AS 에 남으므로 분석·보관이 끝나면 로봇 편집(상태 정정)으로 사람이
 * 내보내야 한다 — 회수 창이 그 자리에서 그렇게 고지한다.
 */
export const ROBOT_RETURN_LOCATIONS = ['AS_CENTER', 'FACTORY', 'RESEARCH', 'WAREHOUSE'];
/**
 * 회수 장소 기본값 — 2026-10-20 오너 "AS센터, 공장으로 나누지 말고 그냥 공장으로 통합"으로 공장.
 * 값을 안 보내는 옛 클라이언트도 공장으로 들어간다.
 */
export const DEFAULT_ROBOT_RETURN_LOCATION = 'FACTORY';
/**
 * 화면이 보여 주는 회수 장소 선택지(2026-10-20) — 'AS 센터'는 '공장'으로 합쳐 뺐다. 값 자체
 * (AS_CENTER)는 옛 클라이언트 · 옛 기록 때문에 ROBOT_RETURN_LOCATIONS 에 남기되, 서버가 회수할 때
 * 공장으로 바꿔 적는다(normalizeReturnLocation). 선택지는 이 목록을 순회해 만든다.
 */
export const ROBOT_RETURN_LOCATION_CHOICES = [
    'FACTORY',
    'RESEARCH',
    'WAREHOUSE',
];
/** AS 센터 → 공장(2026-10-20 통합). 나머지는 그대로. */
export function normalizeReturnLocation(location) {
    return location === 'AS_CENTER' ? 'FACTORY' : location;
}
/**
 * 회수 장소 표기 정본 — 회수 창(로봇 상세)과 활성 고객사 [회수 완료]가 **같은 이 맵을
 * 순회해** 선택지를 만든다(`<option>` 하드코딩 금지 — 값이 늘 때 한 화면만 고쳐지는
 * 사고를 막는다).
 *
 * 문구는 로봇 목록·상세의 위치 배지(LocationPill)와 **같은 말**을 쓴다. 같은 로봇의
 * 같은 위치가 회수 창에서는 'A/S센터', 목록에서는 'AS 센터'로 보이면 그게 더 헷갈린다.
 * 두 표기가 갈리지 않는지는 ReturnRobotModal.test.tsx 의 드리프트 시험이 지킨다.
 */
export const ROBOT_RETURN_LOCATION_LABELS = {
    AS_CENTER: 'AS 센터',
    FACTORY: '공장',
    RESEARCH: '연구소',
    WAREHOUSE: '창고',
};
/**
 * 결정 ①A — 이 장소로 회수했을 때 정비 작업 지시(ServiceOrder)를 자동 생성하는가.
 *
 * 서버(두 회수 경로)와 화면(회수 창 안내문)이 **같은 이 함수**로 판정한다. 종전처럼
 * 각자 조건을 갖고 있으면 "화면은 만들어진다고 했는데 안 만들어지는" 어긋남이 난다.
 */
export function createsReturnMaintenanceOrder(location) {
    return location === 'AS_CENTER' || location === 'FACTORY';
}
// ── 서명 문서 '고른 페이지' 파일명 표기 정본 (개선 9건 차수2b(26-08-04) 결함④) ──
//
// 차수1 은 같은 알고리즘("연속 3장 이상은 범위로 접는다")을 **두 곳에 한 글자씩
// 복제**했다: 서버 `pdf-page-selection.ts`(formatPageSelection + service 의
// withPageSuffix)와 콘솔 `SignDocumentPagePicker.tsx`(pageFileName). 두 벌은 그냥
// 중복이 아니라 **어느 쪽이 이기는지가 뒤집힌** 중복이었다: 서버가
// `Content-Disposition` 을 보내지만 콘솔의 downloadBlob 이 `filename="…"`(큰따옴표)만
// 파싱하므로 매칭이 없어 콘솔이 넘긴 fallback 이름으로 저장된다 → **사본이 실제
// 파일명을 결정한다.** 사본이 어긋나면 서버 로그·감사와 재고팀 폴더의 파일이 다른
// 이름을 갖는다(무엇이 무엇인지 대조 불가).
//
// 그래서 규칙을 shared 로 올려 **양쪽이 같은 함수를 부른다.** 순수 함수라 서버(Nest)
// 와 콘솔(브라우저) 어디서도 의존성 없이 돈다.
/**
 * 파일명에 붙일 페이지 표기. 연속 **3장 이상**은 범위로 접는다(전 페이지를 고른
 * 경우에 파일명이 끝없이 길어지는 것을 막는다). 2장은 접지 않는다 — "3,4" 가
 * "3-4" 보다 짧지 않고, 사람이 두 장임을 바로 안다.
 *
 * 입력은 **오름차순 유일값**을 전제한다(서버는 parsePageSelection 이, 콘솔은
 * 선택 Set 의 sort 가 보장한다). 정렬되지 않은 입력을 여기서 다시 정렬하지 않는
 * 이유: 그러면 "정렬은 누가 하나"가 두 곳에 생겨 같은 종류의 중복이 다시 자란다.
 */
export function formatPageSelection(pages) {
    const out = [];
    let i = 0;
    while (i < pages.length) {
        let j = i;
        while (j + 1 < pages.length && pages[j + 1] === pages[j] + 1)
            j += 1;
        const runLength = j - i + 1;
        if (runLength >= 3) {
            out.push(`${pages[i]}-${pages[j]}`);
        }
        else {
            for (let k = i; k <= j; k += 1)
                out.push(String(pages[k]));
        }
        i = j + 1;
    }
    return out.join(',');
}
/**
 * 고른 페이지를 파일명에 적는다 — `문서.pdf` + [3,4] → `문서 (3,4p).pdf`.
 * 선택이 없으면(null·빈 배열 = '문서 전체') 이름을 그대로 둔다.
 *
 * 전체 문서와 같은 이름으로 저장되면 재고팀 폴더에서 무엇이 무엇인지 구분되지 않는다.
 */
export function withPageSuffix(filename, pages) {
    if (!pages || pages.length === 0)
        return filename;
    const dot = filename.lastIndexOf('.');
    const stem = dot > 0 ? filename.slice(0, dot) : filename;
    const ext = dot > 0 ? filename.slice(dot) : '.pdf';
    return `${stem} (${formatPageSelection(pages)}p)${ext}`;
}
/** 고장 조치 이력 표에서 눌러 정렬하는 칸. */
export const FAULT_REMEDIATION_SORT_COLUMNS = [
    'status',
    'issueCategory',
    'reportNo',
    'store',
    'robot',
    'errorCode',
    'occurredAt',
];
// ============================================================
// 구글 시트 탭 거울 (2026-10-23) — 인바운드 문의 현황 시트의 탭을 콘솔에서 보고 고친다.
// 앱스 스크립트: docs/integrations/sheet-mirror/SheetMirrorSync.gs. 정본은 시트다.
// ============================================================
/** 콘솔이 아는 탭(하나짜리) — 스크립트 설정의 탭 열쇠와 같다. 콘솔에서 고칠 수 있다. */
export const SHEET_MIRROR_TAB_KEYS = ['demo-conversion'];
/**
 * 달마다 탭이 하나씩 생기는 묶음 — 열쇠는 `<묶음>-YYMM`(예: 'auto-ib-2610' = '자동 IB(26.10)').
 *   · auto-ib : '자동 IB(YY.MM)' — 오너: 읽기 전용, 자동 IB 가 생긴 26.03 부터.
 *   · inquiry : '도입문의 현황 (YYYY_M) 수기' — 2026-10-23 오너: 콘솔에서 고칠 수 있게, 26.01 부터.
 */
export const SHEET_MIRROR_MONTHLY_GROUPS = ['auto-ib', 'inquiry'];
/** 콘솔에서 못 고치는 달 묶음 — 시트의 수식이 채운다. */
const SHEET_MIRROR_READ_ONLY_GROUPS = ['auto-ib'];
const SHEET_MIRROR_MONTHLY_KEY = /^([a-z-]+)-(\d{2})(\d{2})$/;
/** 'auto-ib-2610' → { group: 'auto-ib', month: '2026-10' }. 달 탭 열쇠가 아니면 null. */
export function parseSheetMirrorMonthlyKey(key) {
    const m = SHEET_MIRROR_MONTHLY_KEY.exec(key);
    if (!m || !SHEET_MIRROR_MONTHLY_GROUPS.includes(m[1]))
        return null;
    const mm = Number(m[3]);
    if (mm < 1 || mm > 12)
        return null;
    return { group: m[1], month: `20${m[2]}-${m[3]}` };
}
export function isSheetMirrorTabKey(key) {
    return (SHEET_MIRROR_TAB_KEYS.includes(key) ||
        parseSheetMirrorMonthlyKey(key) !== null);
}
/** 콘솔에서 못 고치는 탭 — 자동 IB 달 탭(시트의 수식이 채운다). 도입문의 수기 탭은 고친다. */
export function isSheetMirrorReadOnly(key) {
    const p = parseSheetMirrorMonthlyKey(key);
    return !!p && SHEET_MIRROR_READ_ONLY_GROUPS.includes(p.group);
}
/** 칸 모양 — 스크립트가 시트의 드롭다운 · 값 모양에서 읽는다. */
export const SHEET_MIRROR_COLUMN_TYPES = ['text', 'date', 'number', 'list'];
export const SHEET_MIRROR_EDIT_STATUSES = [
    'PENDING',
    'SENT',
    'APPLIED',
    'CONFLICT',
    'FAILED',
];
/** 필드 대시보드에서 손으로 고칠 수 있는 글 칸 — 신규 이슈 · 주요 누적 이슈. */
export const FIELD_ISSUE_NOTE_SECTIONS = ['NEW', 'RECURRING'];
//# sourceMappingURL=api-contracts.js.map